import { NodeCircleProgram } from "sigma/rendering";
import { cachedProgram } from "./cached-program.js";
// Visual radii remain map texture. Picking radii are CSS-pixel minima so
// Sigma's downsized picking framebuffer cannot lose subpixel marks.
export function atlasNodeProgram(mobile) {
  return class AtlasNodeProgram extends cachedProgram(NodeCircleProgram) {
    getDefinition(){
      const base=super.getDefinition();
      return {...base,UNIFORMS:[...base.UNIFORMS,"u_atlasHitRadius"],
        VERTEX_SHADER_SOURCE:base.VERTEX_SHADER_SOURCE
          .replace("void main()", "uniform float u_atlasHitRadius;\nvoid main()")
          .replace("float size = a_size *", "#ifdef PICKING_MODE\n float visualSize = max(a_size, u_atlasHitRadius * u_sizeRatio);\n#else\n float visualSize = a_size;\n#endif\n float size = visualSize *")};
    }
    setUniforms(params,info){
      super.setUniforms(params,info);
      info.gl.uniform1f(info.uniformLocations.u_atlasHitRadius,mobile()?8:3);
    }
  };
}
